import { FreeSpinsInfoEvent, SpinResponse } from '@cgs/data-access';
import { ResponseHolder } from '../response_holder';
import { BaseGameState } from '../states/base_game_state';
import { BaseGameRule } from './infra/base_game_rule';

export class ScatterToCustomFreeSpins<
  TResponse extends SpinResponse,
> extends BaseGameRule<TResponse> {
  constructor(sourceState: BaseGameState<TResponse>, responseHolder: ResponseHolder<TResponse>) {
    super(sourceState, responseHolder);
  }

  ruleCondition(resp: ResponseHolder<TResponse>): boolean {
    return (
      !resp.curResponse.isBonus &&
      !!resp.curResponse.freeSpinsInfo &&
      resp.curResponse.freeSpinsInfo.event !== FreeSpinsInfoEvent.FreeSpinsFinished
    );
  }
}
